import { z } from 'zod';

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
  VITE_RAILWAY_API_URL: z.string().url().or(z.literal('')).optional(),
  // Dev-only — when set in .env.local, /login shows a one-click dev sign-in
  // button. Branch is tree-shaken from prod builds via import.meta.env.DEV.
  VITE_DEV_LOGIN_EMAIL: z.string().email().optional(),
  VITE_DEV_LOGIN_PASSWORD: z.string().min(1).optional(),
});

export type Env = z.infer<typeof envSchema>;

function loadEnv(): Env {
  const result = envSchema.safeParse(import.meta.env);
  if (!result.success) {
    const issues = result.error.issues.map((i) => `${i.path.join('.')}: ${i.message}`).join('; ');
    throw new Error(`Invalid environment configuration: ${issues}`);
  }
  return result.data;
}

export const env = loadEnv();
